import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FiVideo } from 'react-icons/fi';

import { extractMeetingJoinUrl, getMeetingJoinUrl } from '../utils/meeting-description';

export const JoinMeetingButton: FC<{ joinUrl?: string | null; description?: string | null }> = ({
  joinUrl,
  description,
}) => {
  const { t } = useTranslation();

  const link = getMeetingJoinUrl(joinUrl) ?? extractMeetingJoinUrl(description);
  if (!link) return null;

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-brand-default px-4 py-2 text-base font-semibold text-neutral-on-brand transition-all duration-200 ease-in-out hover:bg-brand-hover hover:shadow-lg hover:shadow-brand-default/25"
    >
      <FiVideo size={16} className="flex-shrink-0" />
      {t('meeting-secretary.meetings.join-meeting')}
    </a>
  );
};
